module.exports = __webpack_public_path__ + "media/images/metronic/social/forrst-dec8eeba1a104bc3bebebb2809385ea1.png";